/**
 * Local field declaration for the trending-markets row surfaced inside `SearchModal`
 * (empty-state + no-results fallback) and hover-prefetched by
 * `SearchInputButton`. The projection lives in a plain (non-`'use client'`)
 * module so the markets-page SSR prefetch can import it without pulling a
 * client component into the server bundle.
 *
 * The fixed MarketCardDto hook no longer receives this declaration as
 * `fields`; it remains an auditable local shape for the rendered search row.
 */
export type TrendingSearchField =
  | 'pubkey'
  | 'title'
  | 'category'
  | 'status'
  | 'coverImageUrl'
  | 'coverImageNsfw'
  | 'volumeTotal'
  | 'prizePool'
  | 'marketConfig'
  | 'ticker'
  | 'outcomeCount';

export const TRENDING_SEARCH_FIELDS: readonly TrendingSearchField[] = [
  'pubkey',
  'title',
  'category',
  'status',
  'coverImageUrl',
  'coverImageNsfw',
  'volumeTotal',
  'prizePool',
  'marketConfig',
  'ticker',
  'outcomeCount',
];

/** Re-export so modal, hover-prefetch, and SSR share one token with the feed. */
export { TRENDING_SEARCH_STATUS } from '@/lib/market/listing-status';

/**
 * Number of trending markets shown in the modal empty state. Applied at the
 * render leaf (`trendingMarkets.slice(0, TRENDING_SEARCH_LIMIT)`) — the SDK
 * `useGetMarkets` args do NOT pass `limit` because the manifest's
 * `pagination.pageSize` (24) governs the page payload size, and the v2 args
 * type does not expose `limit` as a per-call override. Slicing client-side
 * keeps the cache key shared across the modal, the hover prefetch, and the
 * SSR prefetch — all three call sites send the same args and read from the
 * same warmed entry.
 */
export const TRENDING_SEARCH_LIMIT = 6;
